import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type TextButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	children: ReactNode;
	className?: string;
};

const TextButton = ({ children, className, ...props }: TextButtonProps) => {
	return (
		<button
			type="button"
			{...props}
			className={twMerge(
				'cursor-pointer py-1 text-mantang-gray-500 text-xs',
				className,
			)}
		>
			{children}
		</button>
	);
};

export default TextButton;
